import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import { LoadingButton } from '@mui/lab';
import Typography from '@mui/material/Typography';
import {
  Box,
  Dialog,
  FormHelperText,
  Grid,
  SvgIcon,
  TextField,
} from '@mui/material';
import closeIcon from '../../../../assets/accountSetting-assets/x-circle.svg';
import {
  AuthCardComponent,
  classes,
} from '../../document-management/documents/utils';
import { ReactComponent as CopyIcon } from '../../../../assets/common-assets/copy.svg';
import CustomTooltip from '../../utils/CustomTooltip';
import { lightPalette } from '../../../../theme';
import { REFER_A_FRIEND, UTILS } from '../../../../constants/staticContent';
import ExpiryTimeDropdown from '../../utils/ExpiryTimeDropdown';

const ReferAFriendPopUp = ({
  open,
  handleClose,
  setEmailError,
  emailError,
  setEmail,
  email,
  selectedExpiration,
  setSelectedExpiration,
  sendEmailHandler,
  referralCode,
  isButtonLoading,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipTitle, setTooltipTitle] = useState('Copy Code to Clipboard');

  const handleOnChange = (e) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError('');
    }
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(referralCode).then(() => {
      setTooltipTitle('Referral Code Copied');
      setTooltipOpen(true);

      setTimeout(() => {
        setTooltipOpen(false);
        setTooltipTitle('Copy Code to Clipboard');
      }, 2000);
    });
  };

  const handleMouseEnter = () => {
    if (!tooltipOpen) {
      setTooltipTitle('Copy Code to Clipboard');
    }
  };

  const handleExpireTimeValue = (newValue) => {
    setSelectedExpiration(newValue);
  };

  return (
    <Dialog open={open}>
      <AuthCardComponent
        className={`${classes.cardComponent} ${classes.cardComponentExtraHight}`}
      >
        <CardHeader
          className={classes.cardHeader}
          title={
            <Grid container alignItems="center">
              <Grid item xs={10}>
                <Typography variant="h6">
                  {REFER_A_FRIEND.REFER_A_FRIEND}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Avatar
                  onClick={handleClose}
                  src={closeIcon}
                  className={classes.closeAction}
                />
              </Grid>
            </Grid>
          }
        />

        <CardContent
          className={classes.cardContent}
          display="flex"
          alignItems="center"
          flexDirection="column"
        >
          <Box
            className={classes.inputFieldsParentBox}
            display="flex"
            alignItems="center"
            flexDirection="column"
            gap={1}
          >
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              flexDirection="column"
            >
              <Typography
                variant="body1"
                className={classes.GridItemsTypography}
              >
                {REFER_A_FRIEND.REFERRAL_CODE}
              </Typography>
              <Box display="flex" alignItems="center">
                <Box>
                  <Typography
                    variant="h2"
                    className={classes.GridItemsTypography}
                    paddingBottom={0}
                  >
                    {referralCode}
                  </Typography>
                </Box>
                <Box pl={1}>
                  <CustomTooltip
                    title={tooltipTitle}
                    open={tooltipOpen}
                    placement="top"
                  >
                    <SvgIcon
                      component={CopyIcon}
                      sx={{ cursor: 'pointer', fill: 'none' }}
                      onMouseEnter={handleMouseEnter}
                      stroke={lightPalette.primary.main}
                      onClick={handleCopyClick}
                    />
                  </CustomTooltip>
                </Box>
              </Box>
              {/* <TextField
                required
                fullWidth
                size="small"
                name="Referral Code"
                value={referralCode}
                className={classes.GridItemTextfield}
                // onChange={handleOnChange}
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <CustomTooltip title={tooltipTitle} open={tooltipOpen} placement="top">
                        <SvgIcon
                          component={CopyIcon}
                          sx={{ cursor: 'pointer', fill: 'none' }}
                          onMouseEnter={handleMouseEnter}
                          stroke={lightPalette.primary.main}
                          onClick={handleCopyClick}
                        />
                      </CustomTooltip>
                    </InputAdornment>
                  ),
                }}
                // value={email}
                // error={!!emailError}
              /> */}
            </Box>
            <Box width="100%">
              <Typography
                variant="body1"
                className={classes.GridItemsTypography}
              >
                {REFER_A_FRIEND.EMAIL_ID}
              </Typography>
              <TextField
                required
                fullWidth
                size="small"
                name="email"
                // label="Enter Email id"
                className={classes.GridItemTextfield}
                onChange={handleOnChange}
                value={email}
                // error={!!emailError}
              />
              <Box className={classes.displayNameErrorText}>
                {emailError && (
                  <FormHelperText
                    className={`${classes.formHelperText} ${classes.removeMargin}`}
                  >
                    {emailError}
                  </FormHelperText>
                )}
              </Box>
            </Box>
            <Box width="100%">
              <Typography
                variant="body1"
                className={classes.GridItemsTypography}
              >
                {UTILS.EXPIRY_TIME}
              </Typography>

              <ExpiryTimeDropdown
                selectedExpiration={selectedExpiration}
                handleExpireTimeValue={handleExpireTimeValue}
              />
            </Box>
          </Box>

          <Box display="flex" justifyContent="end" alignItems="end" gap={1}>
            <LoadingButton
              variant="contained"
              alignItems="center"
              className={`${classes.exportButton} ${classes.exportButtonNewStyle}`}
              onClick={() => sendEmailHandler(email)}
              loading={isButtonLoading}
            >
              {REFER_A_FRIEND.SEND}
            </LoadingButton>
          </Box>
        </CardContent>
      </AuthCardComponent>
    </Dialog>
  );
};

ReferAFriendPopUp.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setEmailError: PropTypes.func.isRequired,
  emailError: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  setSelectedExpiration: PropTypes.func.isRequired,
  selectedExpiration: PropTypes.shape({
    title: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
  }).isRequired,
  sendEmailHandler: PropTypes.func.isRequired,
  referralCode: PropTypes.string.isRequired,
  isButtonLoading: PropTypes.bool.isRequired,
};

export default ReferAFriendPopUp;
